<template>
<!--  -->
  <div class='policies-regulation'>
    <div style="">
      <CarouselPage></CarouselPage>
    </div>
    <div style='background: #f5f5f5; padding: 20px 8%;'>
      <div class='list'>
        <div class='title'>
          <div class='left'>
            <span>{{title}}</span>
            <span>/NEWS</span>
          </div>
          <div class='right'>
            <!-- <Button shape="circle">MORE</Button> -->
          </div>
        </div>
        <div class='content'>
          <p v-for='(item, index) in list' :key='"list-item-" + index'>
            <span @click='handleDeal(item)' style="cursor: pointer;">{{item.title}}</span>
            <span>{{item.pubTime}}</span>
          </p>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: center;" v-show='totalCount > 0'>
            <Page class-name='pageBorder' :total="totalCount" :page-size="size" :current="num"
                  @on-change="changePage">
            </Page>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getPolicesAndRegulationList } from '@/api/homePage.js'
import CarouselPage from './carouselPage.vue'

export default {
  name: '',
  props: {

  },
  data () {
    return {
      carousel: 0,
      imgList: [1,2,3,4,5],
      title: '',
      list: [],
      num: 1,
      size: 10,
      totalCount: 0
    }
  },
  mixins: [],
  components: {
    CarouselPage
  },
  computed: {

  },
  watch: {
    '$route': function() {
      this.getList()
    }
  },
  created () {
    this.getList()
  },
  mounted () {

  },
  methods: {
    getList() {
      let param = {}
      if (this.$route.query.type == '政策法规') {
        this.title = '政策法规'
        param = {num: this.num, size: this.size, title: '', typeCode: '01', pubStateCode: '02'}
      } else {
        this.title = '通知公告'
        param = {num: this.num, size: this.size, title: '', typeCode: '02', pubStateCode: '02'}
        this.imgList = [5,4,3,2,1]
      }
      getPolicesAndRegulationList(param).then((res) => {
        if (res.status === 200) {
          const { list, total } = res.data.data
          if (Array.isArray(list)) {
            this.totalCount = total
            this.list = list
          }
        }
      })
    },
    changePage() {
      this.getList()
    },
    handleDeal(row) {
      this.$router.push({
          name: 'policiesAndRegulationsDetail',
          query: {
            id: row.id, type: this.$route.query.type == '政策法规' ? '01' : '02'
          }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.policies-regulation {
  background: #EEF3F6;
  .list {
    padding: 20px;
    background: #fff;
    border-radius: 3px;
    .title {
      height: 50px;
      border-bottom: 2px solid #DEDEDE;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .left {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        padding-bottom: 13px;
        span {
          color: #A8A8A8;
        }
        span:first-child {
          color: #333;
          font-size: 18px;
          font-weight: 600;
          padding-left: 8px;
          position: relative;
          margin-right: 3px;
          &::before {
            content: '';
            position: absolute;
            left: 0px;
            top: -3px;
            height: 30px;
            width: 3px;
            background: #318FF1;
          }
        }
      }
      .right {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
    .content {
      padding: 20px;
      p {
        border-bottom: 1px solid #E8E8E8;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 50px;
        align-items: center;
        span {
          color: #D2D2D2;
          font-size: 12px;
          padding-right: 5px;
          width: 100px;
          text-align: right;
        }
        span:first-child {
          text-align: left;
          font-size: 15px;
          white-space: nowrap;
          color: #808080;
          height: 48px;
          display: inline-block;
          width: 100%;
          overflow: hidden;
          line-height: 48px;
          text-overflow: ellipsis;
          padding-left: 18px;
          position: relative;
          margin-left: 10px;
          &::before {
            content: '';
            position: absolute;
            left: 0px;
            top: -3px;
            height: 10px;
            width: 10px;
            border: 1px solid #D0D0D0;
            border-radius: 5px;
            top: 50%;
            transform: translate(0, -50%);
          }
        }
      }
    }

  }
}
</style>
<style lang="less">
.pageBorder {
    .ivu-page-item {
        border-radius: 100%;
    }
    .ivu-page-prev {
        border-radius: 100%;
    }
    .ivu-page-next {
        border-radius: 100%;
    }
    .ivu-page-next {
        border-radius: 30px;
    }
    .ivu-page-options-elevator input {
        border-radius: 30px;
    }
}
</style>
